import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { FilterModule } from '@starfish-access/core';
import { StarfishCommonModule } from '@starfish-access/shared';
import { ApprovalTaskComponent } from './approval-task/approval-task.component';
import { AuditFacade } from './audit.facade';
import { routes } from './audit.routing';

@NgModule({
  imports: [
    CommonModule,
    StarfishCommonModule,
    FilterModule,
    MatCardModule,
    MatTableModule,
    MatProgressBarModule,
    MatButtonModule,
    RouterModule.forChild(routes),
  ],
  declarations: [ApprovalTaskComponent],
  exports: [RouterModule],
  providers: [AuditFacade],
})
export class AuditModule {}
